<div class="page-wrapper manage-event">
  <HomeNavBar />
  <InactivityModal />
  <div v-if="is_loading" class="text-center py-5 w-100">
  <div class="spinner-border text-secondary" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
  <p class="mt-2 mb-0 text-muted">Loading</p>
</div>
  <div v-else>
    <!-- Top nav bar -->
    <div class="card rounded px-4 py-3">
      <div class="row align-items-center gy-2">
        <!-- LEFT -->
        <div class="col-12 col-md-4 d-flex align-items-center gap-3">
          <span
            class="text-muted small cursor-pointer d-flex align-items-center gap-1"
            @click="back"
          >
            <i class="bi bi-arrow-left"></i>
            Back to events
          </span>

          <span
            class="badge rounded d-inline-flex align-items-center gap-1 small fw-medium"
            :class="event?.is_published
                    ? 'bg-success-subtle text-success border border-success'
                    : 'bg-warning-subtle text-warning border border-warning'"
          >
            <i
              :class="event?.is_published ? 'bi bi-check-circle-fill' : 'bi bi-pencil-fill'"
            ></i>
            {{ event?.is_published ? 'Published' : 'Draft' }}
          </span>
        </div>

        <!-- CENTER (title) -->
        <div class="col-12 col-md-4 text-md-center text-start overflow-hidden">
          <div class="fw-bold portal-truncate">{{ event?.event_name }}</div>
        </div>

        <!-- RIGHT -->
        <div
          class="col-12 col-md-4 d-flex justify-content-md-end gap-2 flex-wrap flex-md-nowrap"
        >
          <button
            class="btn btn-sm btn-primary rounded text-xxs cursor-pointer nav-item.position-relative"
            @click="go_to_event"
          >
            View Event
          </button>
        </div>
      </div>
    </div>

    <!-- Main layout -->
    <div class="my-1 me-lg-2 scrollable-container">
      <input
        type="file"
        ref="fileInput"
        class="d-none"
        accept="image/*"
        @change="on_file_change"
      />
      <div class="row">
        <!-- Publish checklist (Moves to Right on Desktop, stays Top on Mobile) -->
        <div
          v-if="active_manage_tab === 'basic'"
          class="col-lg-4 order-lg-2 d-none d-lg-flex flex-column gap-1"
        >
           <!-- Cover image upload Card -->
          <div
            class="card rounded overflow-hidden mb-2"
            role="button"
            @click="trigger_upload"
          >
            <div
              v-if="!cover_image_preview"
              class="card-body d-flex flex-column align-items-center justify-content-center banner-cover"
            >
              <div class="upload-icon-circle">
                <i class="bi bi-image text-muted fs-4"></i>
              </div>
              <p class="mb-0 text-primary fw-medium text-xxxs">
                Upload cover image
              </p>
            </div>

            <div v-else class="position-relative banner-cover">
              <div class="ratio ratio-4x3">
                <img
                  :src="cover_image_preview"
                  class="marketplace-card-image event-image-container"
                  alt="Cover Preview"
                />
              </div>
              <div class="position-absolute top-0 end-0 m-2">
                <button
                  class="btn btn-sm btn-primary border shadow-sm text-xxxs fw-medium px-3 py-2"
                  @click.stop="trigger_upload"
                >
                  <i class="bi bi-arrow-repeat me-1"></i> Change image
                </button>
              </div>
            </div>
          </div>

          <!-- Publish checklist (Desktop) -->
          <div :class="['card rounded', is_free ? 'my-1' : 'mt-1 mb-5']">
            <div class="card-body">
              <div class="d-flex justify-content-between mb-2">
                <p class="text-xxs fw-500 mb-0">Publish checklist</p>
                <span class="text-muted text-xxxs">{{ checked_count }}/{{ check_list.length }}</span>
              </div>
              <div class="progress mb-3 progress">
                <div
                  class="progress-bar bg-banner-gradient"
                  role="progressbar"
                  :style="{ width: progress_width }"
                  aria-valuenow="25"
                  aria-valuemin="0"
                  aria-valuemax="100"
                ></div>
              </div>

              <div class="d-flex flex-column gap-2 mb-3">
                <div
                  v-for="item in check_list"
                  :key="item.label"
                  class="d-flex align-items-center gap-2 text-xxs"
                  :class="item.done ? 'text-body' : 'text-muted'"
                >
                  <i v-if="item.done" class="bi bi-check-circle-fill text-success"></i>
                  <i v-else class="bi bi-circle text-secondary"></i>
                  {{ item.label }}
                </div>
              </div>
              <!-- Smart Publish Area -->
              <div class="d-flex flex-column gap-3">
                <!-- Info Alert (Show if not published and has issues) -->
                <div
                  v-if="(!is_checklist_complete || !date_validation_passed)"
                  class="alert alert-secondary d-flex align-items-start gap-2 text-xxs mb-0 py-2"
                  role="alert"
                >
                  <i class="bi bi-info-circle-fill mt-1 flex-shrink-0"></i>
                  <div class="d-flex flex-column gap-1 text-start">
                    <span v-if="!is_checklist_complete" class="fw-600">Complete the checklist above to publish.</span>
                    <div v-if="!date_validation_passed">
                      <span class="fw-600">Resolve validation errors to publish:</span>
                      <ul class="mb-0 ps-3">
                        <div v-for="(msg, key) in errors" :key="key">
                          <li v-if="msg">{{ msg }}</li>
                        </div>
                      </ul>
                    </div>
                  </div>
                </div>

                <!-- Action Buttons -->
                <div class="d-flex flex-column gap-2">
                  <!-- Save Changes Button (shown if dirty) -->
                  <div v-if="has_unsaved_changes">
                    <button
                      :class="['btn btn-sm d-flex align-items-center gap-1 text-xxs cursor-pointer text-white rounded w-100 justify-content-center py-2', has_unsaved_changes ? 'btn-warning' : 'btn-primary']"
                      @click="update_event"
                      :disabled="!can_save_draft"
                    >
                      Save changes
                    </button>
                  </div>
                  <!-- Publish/Unpublish Button -->
                  <div v-if="!has_unsaved_changes">
                    <button
                      v-if="!event?.is_published && (!is_checklist_complete || !date_validation_passed)"
                      class="btn btn-sm btn-secondary d-flex align-items-center gap-1 text-xxs w-100 justify-content-center py-2 opacity-50 cursor-not-allowed"
                      disabled
                    >
                      <i class="bi bi-send-fill me-1"></i>
                      Publish Event
                    </button>
                    <button
                      v-else
                      class="btn btn-sm btn-primary d-flex align-items-center gap-1 text-xxs w-100 justify-content-center py-2"
                      @click="publish_event"
                    >
                      <i :class="event.is_published ? 'bi bi-send-slash-fill' : 'bi bi-send-fill'" class="me-1"></i>
                      {{ event.is_published ? 'Unpublish' : 'Publish Event' }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Main Content (Moves to Left on Desktop, stays Bottom on Mobile) -->
        <div
          class="d-flex flex-column mb-5 mb-xl-0"
          :class="active_manage_tab === 'basic' ? 'col-lg-8 order-lg-1' : 'col-12'"
        >
          <!-- Tabs + Advanced actions -->
          <div class="rounded p-2 mb-2 d-flex align-items-center w-100">
            <div
              class="d-inline-flex gap-2"
              role="tablist"
              aria-label="Manage event tabs"
            >
              <button
                type="button"
                class="btn btn-sm border-0 rounded px-3 py-2 text-xxs"
                :class="active_manage_tab === 'basic' ? 'bg-light shadow-sm text-dark fw-semibold' : 'bg-transparent text-muted fw-500'"
                @click="set_manage_tab('basic')"
              >
                Basic info
              </button>
              <button
                type="button"
                class="btn btn-sm border-0 rounded px-3 py-2 text-xxs"
                :class="active_manage_tab === 'advanced' ? 'bg-white shadow-sm text-dark fw-semibold' : 'bg-transparent text-muted fw-500'"
                @click="set_manage_tab('advanced')"
              >
                Advanced
              </button>
            </div>
          </div>

          <!-- Cover image upload (Mobile) -->
          <div
            v-if="active_manage_tab === 'basic'"
            class="card rounded overflow-hidden mb-2 d-lg-none"
            role="button"
            @click="trigger_upload"
          >
            <div
              v-if="!cover_image_preview"
              class="card-body d-flex flex-column align-items-center justify-content-center banner-cover"
            >
              <div class="upload-icon-circle">
                <i class="bi bi-image text-muted fs-4"></i>
              </div>
              <p class="mb-0 text-primary fw-medium text-xxxs">
                Upload cover image
              </p>
            </div>

            <div v-else class="position-relative banner-cover">
              <div class="ratio ratio-4x3">
                <img
                  :src="cover_image_preview"
                  class="marketplace-card-image event-image-container"
                  alt="Cover Preview"
                />
              </div>
              <div class="position-absolute top-0 end-0 m-2">
                <button
                  class="btn btn-sm btn-primary border shadow-sm text-xxxs fw-medium px-3 py-2"
                  @click.stop="trigger_upload"
                >
                  <i class="bi bi-arrow-repeat me-1"></i> Change image
                </button>
              </div>
            </div>
          </div>

          <div v-if="active_manage_tab === 'basic'">
          <!-- Event details card -->
          <div class="card rounded">
            <div class="card-body">
              <!--Event Category-->
              <div class="col-md-6 mb-3">
                <label class="form-label text-xxs fw-500">Event Category</label>
                <div class="d-flex flex-row align-items-center gap-3">
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="free_event"
                      name="event_category"
                      :value="true"
                      v-model="is_free"
                      checked
                    />
                    <label class="form-check-label text-xxs" for="free_event">Free</label>
                  </div>
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="paid_event"
                      name="event_category"
                      :value="false"
                      v-model="is_free"
                    />
                    <label class="form-check-label text-xxs" for="paid_event">Paid</label>
                  </div>
                </div>
              </div>
              <!--Organizer-->
              <div class="mb-3">
                <label for="organizer" class="form-label text-xxs fw-500">Organizer</label>
                <input
                  type="text"
                  class="form-control rounded text-xxs"
                  id="organizer"
                  placeholder="Enter organizer name"
                  v-model="organizer"
                />
                <p v-if="errors.organizer" class="text-danger text-xxs">
                  {{ errors.organizer }}
                </p>
              </div>
              <div class="mb-3" v-if="portals.length">
                <label for="portal_id" class="form-label text-xxs fw-500">Portal</label>
                <select
                  id="portal_id"
                  class="form-select rounded text-xxs"
                  v-model="portal_id"
                >
                  <option value="">Select portal</option>
                  <option v-for="portal in portals" :key="portal.id" :value="portal.id">
                    {{ portal.name }}
                  </option>
                </select>
              </div>
              <div class="mb-3" v-if="is_free">
                <label class="form-label text-xxs fw-500">Event Capacity</label>
                <div class="input-group">
                  <input
                    type="number"
                    class="form-control rounded text-xxs"
                    v-model.number="event_capacity"
                    min="0"
                    placeholder="e.g., 100"
                  />
                </div>
                <p v-if="errors.event_capacity" class="text-danger text-xxs">{{ errors.event_capacity }}</p>
            </div>
              <!--Description-->
              <div class="mb-3">
                <label class="form-label text-xxs fw-500">Event Description</label>
                <div>
                  <QuillEditor
                    theme="snow"
                    v-model:content="event_description"
                    contentType="html"
                    ref="quillEventEditorRef"
                    class="quill-editor"
                    placeholder="Enter your description here..."
                    toolbar="full"
                  />
                </div>
              </div>
              <!--Event Start and end date-->
              <div v-if='is_free' class="row">
                <!-- Event Start Date -->
                <div class="col-md-3 mb-3">
                  <label for="start_date" class="form-label text-xxs fw-500"
                    >Event Start Date
                  </label>
                  <input
                    type="date"
                    class="form-control rounded text-xxs"
                    id="start_date"
                    v-model="start_date"
                    :min="today_date"
                  />
                  <p v-if="errors.start_date" class="text-danger text-xxs">
                    {{ errors.start_date }}
                  </p>
                </div>
                <div class="col-md-3 mb-3">
                  <label for="end_time" class="form-label text-xxs fw-500"
                    >Start Time
                  </label>
                  <input
                    type="time"
                    class="form-control rounded text-xxs"
                    id="start_time"
                    v-model="start_time"
                    :min="start_time_min_value()"
                  />

                  <p v-if="errors.start_time" class="text-danger text-xxs mt-1">
                    {{ errors.start_time }}
                  </p>
                </div>

                <!-- Event End Date -->
                <div class="col-md-3 mb-3">
                  <label for="end_date" class="form-label text-xxs fw-500"
                    >Event End Date
                  </label>
                  <input
                    type="date"
                    class="form-control rounded text-xxs"
                    id="end_date"
                    v-model="end_date"
                    :min="event_end_date_min_value()"
                  />
                  <p v-if="errors.end_date" class="text-danger text-xxs">
                    {{ errors.end_date }}
                  </p>
                </div>
                <div class="col-md-3 mb-3">
                  <label for="end_time" class="form-label text-xxs fw-500"
                    >End Time
                  </label>
                  <input
                    type="time"
                    class="form-control rounded text-xxs"
                    id="end_time"
                    v-model="end_time"
                    :min="end_time_min_value()"
                  />
                  <p v-if="errors.end_time" class="text-danger text-xxs">
                    {{ errors.end_time }}
                  </p>
                </div>
                <!-- RSVP Start Date -->
                <div v-if="is_free" class="col-md-3 mb-3">
                  <label
                    for="rsvp_start_date"
                    class="form-label text-xxs fw-500"
                    >RSVP Start Date</label>
                  <input
                    type="date"
                    class="form-control rounded text-xxs"
                    id="rsvp_start_date"
                    v-model="rsvp_start_date"
                    :max="rsvp_start_date_max_value()"
                  />
                  <p v-if="errors.rsvp_start_date" class="text-danger text-xxs">
                    {{ errors.rsvp_start_date }}
                  </p>
                </div>
                <div v-if="is_free" class="col-md-3 mb-3">
                  <label
                    for="rsvp_start_time"
                    class="form-label text-xxs fw-500"
                    >RSVP Start Time</label>
                  <input
                    type="time"
                    class="form-control rounded text-xxs"
                    id="rsvp_start_time"
                    v-model="rsvp_start_time"
                    :min="rsvp_start_time_min_value()"
                    :max="rsvp_start_time_max_value()"
                  />
                  <p v-if="errors.rsvp_start_time" class="text-danger text-xxs">
                    {{ errors.rsvp_start_time }}
                  </p>
                </div>

                <!-- RSVP End Date -->
                <div v-if="is_free" class="col-md-3 mb-3">
                  <label for="rsvp_end_date" class="form-label text-xxs fw-500"
                    >RSVP End Date</label>
                  <input
                    type="date"
                    class="form-control rounded text-xxs"
                    id="rsvp_end_date"
                    v-model="rsvp_end_date"
                    :min="rsvp_end_date_min_value()"
                    :max="rsvp_end_date_max_value()"
                  />
                  <p v-if="errors.rsvp_end_date" class="text-danger text-xxs">
                    {{ errors.rsvp_end_date }}
                  </p>
                </div>
                <div v-if="is_free" class="col-md-3 mb-3">
                  <label for="rsvp_end_time" class="form-label text-xxs fw-500"
                    >RSVP End Time</label>
                  <input
                    type="time"
                    class="form-control rounded text-xxs"
                    id="rsvp_end_time"
                    v-model="rsvp_end_time"
                    :min="rsvp_end_time_min_value()"
                    :max="rsvp_end_time_max_value()"
                  />
                  <p v-if="errors.rsvp_end_time" class="text-danger text-xxs">
                    {{ errors.rsvp_end_time }}
                  </p>
                </div>

              </div>
            </div>
          </div>

          <!-- Ticket types card -->
          <div  v-if="!is_free"  class="card rounded my-2">
            <div class="card-body">
              <div class="d-flex flex-column align-items-start gap-3 mb-3">
                <div class="d-inline-flex align-items-center gap-2 bg-light border rounded-pill px-3 py-2 text-muted text-sm">
                  <i class="bi bi-calendar-event text-primary"></i>
                  <span class="fw-medium text-xxs">
                    {{ new_format_date(start_date + 'T' + start_time) }} - {{ new_format_date(end_date + 'T' + end_time) }}
                  </span>
                </div>
              </div>
              <!-- Header Row -->
              <div
                class="d-flex align-items-center justify-content-between mb-3"
              >
                <div class="d-flex align-items-center gap-2">
                  <i class="bi bi-ticket text-secondary"></i>
                  <span class="text-xxs fw-500">Tickets</span>
                  <span
                    class="d-inline-flex align-items-center justify-content-center rounded-circle text-white fw-bold bg-banner-gradient text-xxxs w-20px h-20"
                  >
                    {{ tickets.length }}
                  </span>
                </div>
                <button
                  type="button"
                  @click="add_ticket"
                  class="d-flex align-items-center bg-primary border rounded px-3 py-2 fw-semibold text-xxs text-white cursor-pointer"
                >
                  Add ticket
                </button>
              </div>
              <!-- Ticket Cards — rendered only after clicking Add -->
              <div
                v-for="(ticket, index) in tickets"
                :key="ticket.id"
                class="border overflow-hidden rounded mb-3"
              >
                <!-- Card Header -->
                <div
                  class="d-flex align-items-center justify-content-between px-3 py-2"
                >
                  <span class="fw-bold text-xxs text-secondary">
                    Ticket {{ index + 1 }}
                  </span>
                  <button
                    v-if="!(event.is_published && ticket.ticket_id)"
                    type="button"
                    @click="remove_ticket(index)"
                    class="d-flex align-items-center justify-content-center border-0 rounded"
                  >
                    <i class="bi bi-x text-danger text-xxs"></i>
                  </button>
                </div>

                <!-- Card Body -->
                <div class="p-3">
                  <!-- Ticket Name -->
                  <div class="mb-3 position-relative">
                    <input
                      type="text"
                      class="form-control rounded text-xxs"
                      v-model="ticket.name"
                      placeholder="Type or select a ticket type"
                      @focus="ticket_show_dropdown = true"
                      @input="ticket_show_dropdown = true"
                      @blur="ticket_show_dropdown = false"
                      autocomplete="off"
                      :disabled="event.is_published && ticket.ticket_id"
                    />
                    <ul
                      class="dropdown-menu w-100 max-h-200"
                      :class="{ show: ticket_show_dropdown && get_filtered_tickets(ticket.name).length }"
                      v-if="ticket_show_dropdown"
                    >
                      <li
                        v-for="t in get_filtered_tickets(ticket.name)"
                        :key="t.id"
                      >
                        <button
                          class="dropdown-item text-xxs"
                          type="button"
                          @mousedown.prevent="ticket.name = t.name; ticket_show_dropdown = false"
                        >
                          {{ t.name }}
                        </button>
                      </li>
                    </ul>
                    <p v-if="errors[`ticket_${index}_name`]" class="text-danger text-xxs mt-1 mb-0">
                      {{ errors[`ticket_${index}_name`] }}
                    </p>
                  </div>

                  <!-- Price & Quantity -->
                  <div class="row g-2">
                    <div class="col-6">
                      <label class="form-label text-xxs fw-500">Price (R)</label>
                      <input
                        type="number"
                        class="form-control rounded text-xxs"
                        v-model.number="ticket.price"
                        step="0.01"
                        min="0"
                        placeholder="0.00"
                        :disabled="event.is_published && ticket.ticket_id"
                      />
                      <p v-if="errors[`ticket_${index}_price`]" class="text-danger text-xxs mt-1 mb-0">
                        {{ errors[`ticket_${index}_price`] }}
                      </p>
                    </div>
                    <div class="col-6">
                      <label class="form-label text-xxs fw-500">Quantity</label>
                      <input
                        type="number"
                        class="form-control rounded text-xxs pac-target-input"
                        v-model.number="ticket.quantity"
                        min="0"
                        placeholder="e.g. 100"
                        :disabled="event.is_published && ticket.ticket_id"
                      />
                      <p v-if="errors[`ticket_${index}_quantity`]" class="text-danger text-xxs mt-1 mb-0">
                        {{ errors[`ticket_${index}_quantity`] }}
                      </p>
                    </div>
                  </div>

                  <!-- Start Date -->
                  <div class="row g-2 mb-2">
                    <div class="mb-2 col-md-6">
                      <label class="form-label text-xxs fw-500">Ticket Sale Start Date <span class="text-danger">*</span></label>
                      <input
                        type="datetime-local"
                        class="form-control rounded text-xxs"
                        v-model="ticket.start_date"
                        :max="ticket_sale_max_datetime()"
                      />
                      <p
                        v-if="errors[`ticket_${index}_start_date`]"
                        class="text-danger text-xxs mt-1 mb-0"
                      >
                        {{ errors[`ticket_${index}_start_date`] }}
                      </p>
                    </div>

                    <!-- End Date -->
                    <div class="col-md-6">
                      <label class="form-label text-xxs fw-500">Ticket Sale End Date <span class="text-danger">*</span></label>
                      <input
                        type="datetime-local"
                        class="form-control rounded text-xxs"
                        v-model="ticket.end_date"
                        :min="ticket_sale_end_min_datetime(ticket)"
                        :max="ticket_sale_max_datetime()"
                      />
                      <p
                        v-if="errors[`ticket_${index}_end_date`]"
                        class="text-danger text-xxs mt-1 mb-0"
                      >
                        {{ errors[`ticket_${index}_end_date`] }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Publish checklist (Mobile) -->
          <div class="d-lg-none">
            <div :class="['card rounded', is_free ? 'my-1' : 'mt-1 mb-5']">
              <div class="card-body">
                <div class="d-flex justify-content-between mb-2">
                  <p class="text-xxs fw-500 mb-0">Publish checklist</p>
                  <span class="text-muted text-xxxs">{{ checked_count }}/{{ check_list.length }}</span>
                </div>
                <div class="progress mb-3 progress">
                  <div
                    class="progress-bar bg-banner-gradient"
                    role="progressbar"
                    :style="{ width: progress_width }"
                    aria-valuenow="25"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>

                <div class="d-flex flex-column gap-2 mb-3">
                  <div
                    v-for="item in check_list"
                    :key="item.label"
                    class="d-flex align-items-center gap-2 text-xxs"
                    :class="item.done ? 'text-body' : 'text-muted'"
                  >
                    <i v-if="item.done" class="bi bi-check-circle-fill text-success"></i>
                    <i v-else class="bi bi-circle text-secondary"></i>
                    {{ item.label }}
                  </div>
                </div>
                <!-- Smart Publish Area -->
                <div class="d-flex flex-column gap-3">
                  <!-- Info Alert (Show if not published and has issues) -->
                  <div
                    v-if="(!is_checklist_complete || !date_validation_passed)"
                    class="alert alert-secondary d-flex align-items-start gap-2 text-xxs mb-0 py-2"
                    role="alert"
                  >
                    <i class="bi bi-info-circle-fill mt-1 flex-shrink-0"></i>
                    <div class="d-flex flex-column gap-1 text-start">
                      <span v-if="!is_checklist_complete" class="fw-600">Complete the checklist above to publish.</span>
                      <div v-if="!date_validation_passed">
                        <span class="fw-600">Resolve validation errors to publish:</span>
                        <ul class="mb-0 ps-3">
                          <div v-for="(msg, key) in errors" :key="key">
                            <li v-if="msg">{{ msg }}</li>
                          </div>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <!-- Action Buttons -->
                  <div class="d-flex flex-column gap-2">
                    <!-- Save Changes Button (shown if dirty) -->
                    <div v-if="has_unsaved_changes">
                      <button
                        :class="['btn btn-sm d-flex align-items-center gap-1 text-xxs cursor-pointer text-white rounded w-100 justify-content-center py-2', has_unsaved_changes ? 'btn-warning' : 'btn-primary']"
                        @click="update_event"
                        :disabled="!can_save_draft"
                      >
                        Save changes
                      </button>
                    </div>
                    <!-- Publish/Unpublish Button -->
                    <div v-if="!has_unsaved_changes">
                      <button
                        v-if="!event?.is_published && (!is_checklist_complete || !date_validation_passed)"
                        class="btn btn-sm btn-secondary d-flex align-items-center gap-1 text-xxs w-100 justify-content-center py-2 opacity-50 cursor-not-allowed"
                        disabled
                      >
                        <i class="bi bi-send-fill me-1"></i>
                        Publish Event
                      </button>
                      <button
                        v-else
                        class="btn btn-sm btn-primary d-flex align-items-center gap-1 text-xxs w-100 justify-content-center py-2"
                        @click="publish_event"
                      >
                        <i :class="event.is_published ? 'bi bi-send-slash-fill' : 'bi bi-send-fill'" class="me-1"></i>
                        {{ event.is_published ? 'Unpublish' : 'Publish Event' }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="is_free" class="card rounded my-2">
            <div class="card-body" v-if="show_add_extras">
              <!-- Header Row (match Tickets) -->
              <div
                class="d-flex align-items-center justify-content-between mb-3"
              >
                <div class="d-flex align-items-center gap-2">
                  <i class="bi bi-tags text-secondary"></i>
                  <span class="text-xxs fw-500">Event Extras</span>
                  <span
                    class="d-inline-flex align-items-center justify-content-center rounded-circle text-white fw-bold bg-banner-gradient text-xxxs w-20px h-20"
                  >
                    {{ extra_forms.length }}
                  </span>
                </div>
                <button
                  type="button"
                  @click.prevent="add_extra"
                  class="d-flex align-items-center bg-primary border rounded px-3 py-2 fw-semibold text-xxs text-white cursor-pointer"
                >
                  Add extra
                </button>
              </div>

              <!-- Extra Cards (match Ticket card layout) -->
              <div v-if="show_extras_form && extra_forms.length > 0">
                <div
                  v-for="(extraForm, extraIndex) in extra_forms"
                  :key="extraIndex"
                  class="border overflow-hidden rounded mb-3"
                >
                  <!-- Card Header -->
                  <div
                    class="d-flex align-items-center justify-content-between px-3 py-2"
                  >
                    <span class="fw-bold text-xxs text-secondary">
                      Extra {{ extraIndex + 1 }}
                    </span>
                    <button
                      type="button"
                      @click.prevent="remove_extra(extraIndex)"
                      class="d-flex align-items-center justify-content-center border-0 rounded"
                    >
                      <i class="bi bi-x text-danger text-xxs"></i>
                    </button>
                  </div>

                  <!-- Card Body -->
                  <div class="p-3">
                    <input
                      v-model="extraForm.id"
                      type="text"
                      class="d-none extra_form_id"
                    />

                    <div class="mb-3">
                      <label class="form-label text-xxs fw-500">Extra Type</label>
                      <input
                        type="text"
                        class="form-control rounded text-xxs"
                        v-model="extraForm.selectedExtra"
                        placeholder="e.g. Meal 1"
                        :list="'extrasList-' + extraIndex"
                      />
                      <datalist :id="'extrasList-' + extraIndex">
                        <option
                          v-for="extra in extras"
                          :key="extra.id"
                          :value="extra.name"
                        ></option>
                      </datalist>
                    </div>

                    <div class="mt-3">
                      <div
                        class="d-flex align-items-center justify-content-between mb-2"
                      >
                        <h6 class="text-xxs mb-0 text-secondary">Items</h6>
                        <button
                          @click.prevent="add_extra_item(extraIndex)"
                          class="d-flex align-items-center bg-primary border rounded px-3 py-2 fw-semibold text-xxs text-white cursor-pointer"
                          type="button"
                        >
                          Add item
                        </button>
                      </div>

                      <div
                        v-for="(item, itemIndex) in extraForm.items"
                        :key="itemIndex + '_extra'"
                        class="border rounded mb-2"
                      >
                        <div class="p-3">
                          <input
                            v-model="item.id"
                            type="text"
                            class="d-none item_id"
                          />

                          <div class="row g-2 align-items-start">
                            <div class="col-12 col-md-3">
                              <label class="form-label text-xxs fw-500">Name</label>
                              <input
                                v-model="item.item_name"
                                type="text"
                                class="form-control rounded text-xxs"
                                placeholder="e.g. Burger, Chips"
                              />
                            </div>

                            <div class="col-12 col-md-5">
                              <label class="form-label text-xxs fw-500">Description</label>
                              <textarea
                                v-model="item.item_description"
                                class="form-control rounded text-xxs"
                                rows="1"
                                placeholder="Enter description"
                              ></textarea>
                            </div>

                            <div class="col-12 col-md-3">
                              <label class="form-label text-xxs fw-500">Price</label>
                              <div class="input-group input-group-sm">
                                <span class="input-group-text text-xxs">R</span>
                                <input
                                  v-model="item.item_price"
                                  type="number"
                                  class="form-control rounded text-xxs"
                                  placeholder="0.00"
                                  step="0.01"
                                  min="0"
                                />
                              </div>
                            </div>

                            <div
                              class="col-12 col-md-1 d-flex justify-content-end align-items-end"
                            >
                              <button
                                @click.prevent="remove_extra_item(extraIndex, itemIndex)"
                                class="d-flex align-items-center justify-content-center border-0 rounded"
                                type="button"
                                title="Remove Item"
                              >
                                <i class="bi bi-x text-danger text-xxs"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          </div>

          <div v-if="active_manage_tab === 'advanced'">
            <!-- Advanced layout -->
            <div class="row">
              <!-- Desktop side tabs -->
              <div class="col-lg-4 order-lg-2 d-none d-lg-flex flex-column gap-1">
                <div class="card rounded">
                  <div class="card-body">
                    <div class="list-group list-group-flush">
                      <button
                        type="button"
                        class="list-group-item list-group-item-action rounded-3 border-0 d-flex align-items-center gap-2 text-xxs"
                        :class="active_advanced_section === 'agenda' ? 'bg-secondary shadow-sm fw-semibold text-white' : 'bg-transparent '"
                        @click="set_advanced_section('agenda')">
                        <i class="bi bi-clock"></i>
                        Agenda
                      </button>
                      <button
                        type="button"
                        class="list-group-item list-group-item-action rounded-3 border-0 d-flex align-items-center gap-2 text-xxs"
                        :class="active_advanced_section === 'speakers' ? 'bg-secondary shadow-sm fw-semibold text-white' : 'bg-transparent'"
                        @click="set_advanced_section('speakers')">
                        <i class="bi bi-mic"></i>
                        Speakers
                      </button>
                      <button
                        type="button"
                        class="list-group-item list-group-item-action rounded-3 border-0 d-flex align-items-center gap-2 text-xxs"
                        :class="active_advanced_section === 'survey' ? 'bg-secondary shadow-sm fw-semibold text-white' : 'bg-transparent'"
                        @click="set_advanced_section('survey')">
                        <i class="bi bi-card-checklist"></i>
                        Survey
                      </button>
                      <button
                        type="button"
                        class="list-group-item list-group-item-action rounded-3 border-0 d-flex align-items-center gap-2 text-xxs"
                        :class="active_advanced_section === 'photo_wall' ? 'bg-secondary shadow-sm fw-semibold text-white' : 'bg-transparent'"
                        @click="set_advanced_section('photo_wall')">
                        <i class="bi bi-images"></i>
                        Event gallery
                      </button>
                      <button
                        type="button"
                        class="list-group-item list-group-item-action rounded-3 border-0 d-flex align-items-center gap-2 text-xxs"
                        :class="active_advanced_section === 'event_slides' ? 'bg-secondary shadow-sm fw-semibold text-white' : 'bg-transparent'"
                        @click="set_advanced_section('event_slides')">
                        <i class="bi bi-easel"></i>
                        Event slides
                      </button>
                      <button
                        v-if="!is_free"
                        type="button"
                        class="list-group-item list-group-item-action rounded-3 border-0 d-flex align-items-center gap-2 text-xxs"
                        :class="active_advanced_section === 'promo_codes' ? 'bg-secondary shadow-sm fw-semibold text-white' : 'bg-transparent'"
                        @click="set_advanced_section('promo_codes')">
                        <i class="bi bi-tag"></i>
                        Promo codes
                      </button>
                      <button
                        type="button"
                        class="list-group-item list-group-item-action rounded-3 border-0 d-flex align-items-center gap-2 text-xxs"
                        :class="active_advanced_section === 'recurring' ? 'bg-secondary shadow-sm fw-semibold text-white' : 'bg-transparent'"
                        @click="set_advanced_section('recurring')">
                        <i class="bi bi-arrow-repeat"></i>
                        Recurring
                      </button>
                      <button
                        type="button"
                        class="list-group-item list-group-item-action rounded-3 border-0 d-flex align-items-center gap-2 text-xxs"
                        :class="active_advanced_section === 'sponsors' ? 'bg-secondary shadow-sm fw-semibold text-white' : 'bg-transparent'"
                        @click="set_advanced_section('sponsors')">
                        <i class="bi bi-award"></i>
                        Sponsors
                      </button>
                    </div>
                  </div>
                </div>

                <div class="card rounded mt-1 mb-5">
                  <div class="card-body">
                    <div class="d-flex justify-content-between mb-2">
                      <p class="text-xxs fw-500 mb-0">Publish checklist</p>
                      <span class="text-muted text-xxxs">{{ checked_count }}/{{ check_list.length }}</span>
                    </div>
                    <div class="progress mb-3 progress">
                      <div
                        class="progress-bar bg-banner-gradient"
                        role="progressbar"
                        :style="{ width: progress_width }"
                        aria-valuenow="25"
                        aria-valuemin="0"
                        aria-valuemax="100"
                      ></div>
                    </div>

                    <div class="d-flex flex-column gap-2 mb-3">
                      <div
                        v-for="item in check_list"
                        :key="item.label"
                        class="d-flex align-items-center gap-2 text-xxs"
                        :class="item.done ? 'text-body' : 'text-muted'"
                      >
                        <i v-if="item.done" class="bi bi-check-circle-fill text-success"></i>
                        <i v-else class="bi bi-circle text-secondary"></i>
                        {{ item.label }}
                      </div>
                    </div>

                    <div class="d-flex flex-column gap-3">
                      <div
                        v-if="(!is_checklist_complete || !date_validation_passed)"
                        class="alert alert-secondary d-flex align-items-start gap-2 text-xxs mb-0 py-2"
                        role="alert"
                      >
                        <i class="bi bi-info-circle-fill mt-1 flex-shrink-0"></i>
                        <div class="d-flex flex-column gap-1 text-start">
                          <span v-if="!is_checklist_complete" class="fw-600">Complete the checklist above to publish.</span>
                          <div v-if="!date_validation_passed">
                            <span class="fw-600">Resolve validation errors to publish:</span>
                            <ul class="mb-0 ps-3">
                              <div v-for="(msg, key) in errors" :key="key">
                                <li v-if="msg">{{ msg }}</li>
                              </div>
                            </ul>
                          </div>
                        </div>
                      </div>

                      <div class="d-flex flex-column gap-2">
                        <div v-if="has_unsaved_changes">
                          <button
                            :class="['btn btn-sm d-flex align-items-center gap-1 text-xxs cursor-pointer text-white rounded w-100 justify-content-center py-2', has_unsaved_changes ? 'btn-warning' : 'btn-primary']"
                            @click="update_event"
                            :disabled="!can_save_draft"
                          >
                            Save changes
                          </button>
                        </div>
                        <div v-if="!has_unsaved_changes">
                          <button
                            v-if="!event?.is_published && (!is_checklist_complete || !date_validation_passed)"
                            class="btn btn-sm btn-secondary d-flex align-items-center gap-1 text-xxs w-100 justify-content-center py-2 opacity-50 cursor-not-allowed"
                            disabled
                          >
                            <i class="bi bi-send-fill me-1"></i>
                            Publish Event
                          </button>
                          <button
                            v-else
                            class="btn btn-sm btn-primary d-flex align-items-center gap-1 text-xxs w-100 justify-content-center py-2"
                            @click="publish_event"
                          >
                            <i :class="event.is_published ? 'bi bi-send-slash-fill' : 'bi bi-send-fill'" class="me-1"></i>
                            {{ event.is_published ? 'Unpublish' : 'Publish Event' }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Main content -->
              <div class="d-flex flex-column mb-5 mb-xl-0 col-lg-8 order-lg-1">
                <!-- Mobile advanced actions -->
                <div v-if="active_manage_tab === 'advanced'" class="d-flex d-lg-none align-items-center gap-2 px-2 mb-2">
                  <button
                    class="btn btn-sm px-3"
                    type="button"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#manageEventAdvancedNav"
                    aria-controls="manageEventAdvancedNav"
                  >
                    <i class="bi bi-list me-1 fs-2"></i>
                  </button>
                </div>

                <div
                  :class="[
                    'card rounded',
                    active_manage_tab === 'advanced' && ['photo_wall', 'event_slides'].includes(active_advanced_section)
                      ? 'mb-2 mb-lg-5'
                      : 'mb-5'
                  ]"
                >
                  <div class="card-body">
                  <div v-if="active_advanced_section === 'speakers'">
                    <EventSpeaker
                      ref="eventSpeakerInlineRef"
                      :event_id="event_id"
                      :event="event"
                      :inline="true"
                    />
                  </div>

                  <div v-else-if="active_advanced_section === 'survey'">
                    <EventSurvey
                      ref="eventSurveyInlineRef"
                      :event_id="event_id"
                      :event="event"
                      :inline="true"
                      @survey-updated="on_survey_updated"
                      @survey-deleted="on_survey_deleted"
                    />
                  </div>

                  <div v-else-if="active_advanced_section === 'photo_wall'">
                    <EventMediaGallery
                      ref="eventMediaGalleryInlineRef"
                      :event_id="event_id"
                      :event="event"
                      :inline="true"
                      @media-updated="on_media_updated"
                      @media-deleted="on_media_deleted"
                      @visibility-updated="on_gallery_visibility_updated"
                    />
                  </div>

                  <div v-else-if="active_advanced_section === 'event_slides'">
                    <EventResource
                      ref="eventResourceInlineRef"
                      :event_id="event_id"
                      :event="event"
                      :inline="true"
                      @documents-updated="on_documents_updated"
                      @document-deleted="on_document_deleted"
                      @visibility-updated="on_slides_visibility_updated"
                    />
                  </div>

                  <div v-else-if="active_advanced_section === 'promo_codes' && !is_free">
                    <PromoCode
                      ref="promoManagerInlineRef"
                      :event_id="event_id"
                      :event="event"
                      :inline="true"
                      @promo-updated="on_promo_updated"
                      @promo-deleted="on_promo_deleted"
                    />
                  </div>

                  <div v-else-if="active_advanced_section === 'recurring'">
                    <div class="d-flex align-items-center gap-2 mb-3">
                      <i class="bi bi-arrow-repeat text-primary"></i>
                      <span class="fw-semibold text-xxs">Recurring Event</span>
                    </div>

                    <div class="mb-3">
                      <label class="form-label text-xxs fw-500">Is Recurring?</label>
                      <div class="d-flex flex-row align-items-center gap-3">
                        <div class="form-check">
                          <input
                            class="form-check-input"
                            type="radio"
                            id="advanced_recurring_yes"
                            :value="true"
                            v-model="is_recurring"
                          />
                          <label class="form-check-label text-xxs" for="advanced_recurring_yes">Yes</label>
                        </div>
                        <div class="form-check">
                          <input
                            class="form-check-input"
                            type="radio"
                            id="advanced_recurring_no"
                            :value="false"
                            v-model="is_recurring"
                          />
                          <label class="form-check-label text-xxs" for="advanced_recurring_no">No</label>
                        </div>
                      </div>
                    </div>

                    <div class="mb-0" v-if="is_recurring">
                      <label for="advanced_recurring_type" class="form-label text-xxs fw-500">Recurrence Pattern <span class="text-danger">*</span></label>
                      <select
                        class="form-select rounded text-xxs"
                        id="advanced_recurring_type"
                        v-model="recurring_type"
                      >
                        <option value="">Select recurrence</option>
                        <option
                          v-for="pattern in recurring_patterns"
                          :key="pattern.id"
                          :value="pattern.id"
                        >
                          {{ pattern.name }}
                        </option>
                      </select>
                      <p v-if="errors.recurring_type" class="text-danger text-xxs">
                        {{ errors.recurring_type }}
                      </p>
                    </div>

                    <div class="d-flex justify-content-end mt-4">
                      <button
                        type="button"
                        class="btn btn-sm btn-warning text-white rounded px-3"
                        @click="save_recurring_settings"
                      >
                        Save changes
                      </button>
                    </div>
                  </div>

                  <div v-else-if="active_advanced_section === 'sponsors'">
                    <EventSponsor
                      ref="eventSponsorInlineRef"
                      :event_id="event_id"
                      :event="event"
                      :inline="true"
                    />
                  </div>

                  <div v-else-if="active_advanced_section === 'agenda'">
                    <EventAgenda
                      ref="eventAgendaInlineRef"
                      :event_id="event_id"
                      :event="event"
                      :inline="true"
                      @agenda-updated="on_agenda_updated"
                    />
                  </div>

                  <div v-else>
                    <div class="d-flex align-items-center gap-2 fw-bold">
                      <i
                        :class="active_advanced_section === 'agenda' ? 'bi bi-clock text-primary'
                          : active_advanced_section === 'photo_wall' ? 'bi bi-images text-primary'
                          : active_advanced_section === 'event_slides' ? 'bi bi-easel text-primary'
                          : active_advanced_section === 'promo_codes' ? 'bi bi-tag text-primary'
                          : active_advanced_section === 'recurring' ? 'bi bi-arrow-repeat text-primary'
                          : 'bi bi-award text-primary'"></i>
                      <span class="text-capitalize">{{ active_advanced_section.replace('_', ' ') }}</span>
                    </div>

                    <div class="text-muted text-sm mt-2">
                      Manage {{ active_advanced_section.replace('_', ' ') }} for this event.
                    </div>

                    <div class="mt-3">
                      <button
                        type="button"
                        class="btn btn-sm btn-primary rounded-pill px-3"
                        @click="open_advanced_section"
                      >
                        Open
                      </button>
                    </div>
                  </div>
                  </div>
                </div>

                <div class="d-lg-none mb-3">
                  <div class="card rounded">
                    <div class="card-body">
                      <div class="d-flex justify-content-between mb-2">
                        <p class="text-xxs fw-500 mb-0">Publish checklist</p>
                        <span class="text-muted text-xxxs">{{ checked_count }}/{{ check_list.length }}</span>
                      </div>
                      <div class="progress mb-3 progress">
                        <div
                          class="progress-bar bg-banner-gradient"
                          role="progressbar"
                          :style="{ width: progress_width }"
                          aria-valuenow="25"
                          aria-valuemin="0"
                          aria-valuemax="100"
                        ></div>
                      </div>

                      <div class="d-flex flex-column gap-2 mb-3">
                        <div
                          v-for="item in check_list"
                          :key="item.label"
                          class="d-flex align-items-center gap-2 text-xxs"
                          :class="item.done ? 'text-body' : 'text-muted'"
                        >
                          <i v-if="item.done" class="bi bi-check-circle-fill text-success"></i>
                          <i v-else class="bi bi-circle text-secondary"></i>
                          {{ item.label }}
                        </div>
                      </div>

                      <div class="d-flex flex-column gap-3">
                        <div
                          v-if="(!is_checklist_complete || !date_validation_passed)"
                          class="alert alert-secondary d-flex align-items-start gap-2 text-xxs mb-0 py-2"
                          role="alert"
                        >
                          <i class="bi bi-info-circle-fill mt-1 flex-shrink-0"></i>
                          <div class="d-flex flex-column gap-1 text-start">
                            <span v-if="!is_checklist_complete" class="fw-600">Complete the checklist above to publish.</span>
                            <div v-if="!date_validation_passed">
                              <span class="fw-600">Resolve validation errors to publish:</span>
                              <ul class="mb-0 ps-3">
                                <div v-for="(msg, key) in errors" :key="key">
                                  <li v-if="msg">{{ msg }}</li>
                                </div>
                              </ul>
                            </div>
                          </div>
                        </div>

                        <div class="d-flex flex-column gap-2">
                          <div v-if="has_unsaved_changes">
                            <button
                              :class="['btn btn-sm d-flex align-items-center gap-1 text-xxs cursor-pointer text-white rounded w-100 justify-content-center py-2', has_unsaved_changes ? 'btn-warning' : 'btn-primary']"
                              @click="update_event"
                              :disabled="!can_save_draft"
                            >
                              Save changes
                            </button>
                          </div>
                          <div v-if="!has_unsaved_changes">
                            <button
                              v-if="!event?.is_published && (!is_checklist_complete || !date_validation_passed)"
                              class="btn btn-sm btn-secondary d-flex align-items-center gap-1 text-xxs w-100 justify-content-center py-2 opacity-50 cursor-not-allowed"
                              disabled
                            >
                              <i class="bi bi-send-fill me-1"></i>
                              Publish Event
                            </button>
                            <button
                              v-else
                              class="btn btn-sm btn-primary d-flex align-items-center gap-1 text-xxs w-100 justify-content-center py-2"
                              @click="publish_event"
                            >
                              <i :class="event.is_published ? 'bi bi-send-slash-fill' : 'bi bi-send-fill'" class="me-1"></i>
                              {{ event.is_published ? 'Unpublish' : 'Publish Event' }}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Mobile offcanvas side tabs -->
            <div
              class="offcanvas offcanvas-start"
              tabindex="-1"
              id="manageEventAdvancedNav"
              aria-labelledby="manageEventAdvancedNavLabel"
            >
              <div class="offcanvas-header mb-5"></div>
              <div class="offcanvas-body p-2">
                <div class="offcanvas-header d-flex justify-content-between align-items-center">
                  <h5 class="offcanvas-title" id="manageEventAdvancedNavLabel">Advanced</h5>
                  <div class="d-flex align-items-center gap-2">
                    <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                  </div>
                </div>
                <div class="list-group list-group-flush">
                  <button
                    type="button"
                    class="list-group-item list-group-item-action rounded d-flex align-items-center gap-2 text-xxs"
                    :class="active_advanced_section === 'agenda' ? 'bg-light fw-semibold' : ''"
                    @click="set_advanced_section('agenda')"
                    data-bs-dismiss="offcanvas"
                  >
                    <i class="bi bi-clock"></i> Agenda
                  </button>
                  <button
                    type="button"
                    class="list-group-item list-group-item-action rounded d-flex align-items-center gap-2 text-xxs"
                    :class="active_advanced_section === 'speakers' ? 'bg-light fw-semibold' : ''"
                    @click="set_advanced_section('speakers')"
                    data-bs-dismiss="offcanvas"
                  >
                    <i class="bi bi-mic"></i> Speakers
                  </button>
                  <button
                    type="button"
                    class="list-group-item list-group-item-action rounded d-flex align-items-center gap-2 text-xxs"
                    :class="active_advanced_section === 'survey' ? 'bg-light fw-semibold' : ''"
                    @click="set_advanced_section('survey')"
                    data-bs-dismiss="offcanvas"
                  >
                    <i class="bi bi-card-checklist"></i> Survey
                  </button>
                  <button
                    type="button"
                    class="list-group-item list-group-item-action rounded d-flex align-items-center gap-2 text-xxs"
                    :class="active_advanced_section === 'sponsors' ? 'bg-light fw-semibold' : ''"
                    @click="set_advanced_section('sponsors')"
                    data-bs-dismiss="offcanvas"
                  >
                    <i class="bi bi-award"></i> Sponsors
                  </button>
                  <button
                    type="button"
                    class="list-group-item list-group-item-action rounded d-flex align-items-center gap-2 text-xxs"
                    :class="active_advanced_section === 'photo_wall' ? 'bg-light fw-semibold' : ''"
                    @click="set_advanced_section('photo_wall')"
                    data-bs-dismiss="offcanvas"
                  >
                    <i class="bi bi-images"></i> Event gallery
                  </button>
                  <button
                    type="button"
                    class="list-group-item list-group-item-action rounded d-flex align-items-center gap-2 text-xxs"
                    :class="active_advanced_section === 'event_slides' ? 'bg-light fw-semibold' : ''"
                    @click="set_advanced_section('event_slides')"
                    data-bs-dismiss="offcanvas"
                  >
                    <i class="bi bi-easel"></i> Event slides
                  </button>
                  <button
                    v-if="!is_free"
                    type="button"
                    class="list-group-item list-group-item-action rounded d-flex align-items-center gap-2 text-xxs"
                    :class="active_advanced_section === 'promo_codes' ? 'bg-light fw-semibold' : ''"
                    @click="set_advanced_section('promo_codes')"
                    data-bs-dismiss="offcanvas"
                  >
                    <i class="bi bi-tag"></i> Promo codes
                  </button>
                  <button
                    type="button"
                    class="list-group-item list-group-item-action rounded d-flex align-items-center gap-2 text-xxs"
                    :class="active_advanced_section === 'recurring' ? 'bg-light fw-semibold' : ''"
                    @click="set_advanced_section('recurring')"
                    data-bs-dismiss="offcanvas"
                  >
                    <i class="bi bi-arrow-repeat"></i> Recurring
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Advanced components are rendered inline per section -->
</div>
